import { globalGetApiUrl } from "@utils/globalBaseUrl";
import { getApiUrl } from "../../utils/baseUrl";

export const autoSuggestLanguageDictionary = {
  english: "EN",
  spanish: "ES",
};

export const filterTypeDictionary = {
  normalFilter: "normal-filter",
  radioFilter: "radio-filter",
  localizeFilter: "localization-filter",
  sliderFilter: "slider-filter",
  proximityFilter: "proximity-filter",
  hsCodeFilter: "hsCode-filter",
  boxFilter: "box-filter",
  rangeFilter: "range-filter",
  weightFilter: "weight-filter",
  teuFilter: "teu-filter",
  upgradeCheckboxFilter: "upgrade-checkbox-filter",
  dataSourceFilter: "data-source-filter",
  multiSelectRangeFilter: "multi-select-range-filter",
  normalAndMultiSelectRangeFilter: "normal-and-multi-select-range-filter",
};

export const analyticsTypeDictionary = {
  trends: "trends",
  horizontalCountry: "horizontalCountry",
  horizontalBar: "horizontalBar",
  verticalBar: "verticalBar",
  hsCode: "hsCode",
  pieChart: "pieChart",
  topTwo: "topTwo",
  topThree: "topThree",
  topFour: "topFour",
};

export const globalAPIDictionary = {
  profile: getApiUrl("getUserProfile"), // Deprecated - kept for backward compatibility
  profileComplete: globalGetApiUrl("auth/getUserProfileComplete"), // New: Complete user profile from auth-service
  profileIntel: getApiUrl("getUserIntelDetails"), // New: Intel-specific details from trademo service
  getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
  featureNudge: getApiUrl("featureNudge"),
  featureNudgeUpdate: getApiUrl("featureNudgeUpdate"),
  checkFirstLand: getApiUrl("checkFirstLand"),
  notification_center: getApiUrl("notification_center/get_notifications"),
  getCustomizedShipmentGrid: getApiUrl("getCustomGridConfiguration"),
  setUserCustomGrid: getApiUrl("setUserCustomGrid"),
  intelSearchHooks: getApiUrl("intelSearchHooks"),
  saveIntelComplianceUserHooks: getApiUrl("save_intel_compliance_user_hooks"),
  getUserComplianceHookData: getApiUrl("get_user_compliance_hook_data"),
  intelSearchHooksSummary: getApiUrl("intelSearchHooksSummary"),
  intelSearchHooksCountryData: getApiUrl("intelSearchHooksCountryData"),
  notifySales: getApiUrl("notifySales"),
  getAutoSuggestRecentSearches: getApiUrl("getAutoSuggestRecentSearches"),
  updateUserDearchStatus: getApiUrl("update_user_search_status"),
  getReportsData: getApiUrl("getAnalyticsReportDetails"),
  getCompanySlug: getApiUrl("getCompanySlug"),
  getSidebarCount: getApiUrl("user_dashboard_sections_count"),
  addFavouriteCompany: getApiUrl("addFavouriteCompany"),
  usersAllFavouriteCompanyTags: getApiUrl("usersAllFavouriteCompanyTags"),
  updateEmailAlertStatus: getApiUrl("updateEmailAlertStatus"),
  getCompanyProfilesSlug: getApiUrl("companyProfiles/getSlug"),
  sendcompanyProfileToZoho: getApiUrl("sendcompanyProfileToZoho"),
  sendcompanyProfileToHubspot: getApiUrl("sendcompanyProfileToHubspot"),
  sendcompanyProfileToSalesforce: getApiUrl("sendcompanyProfileToSalesforce"),
  createExcelFavouriteCompany: getApiUrl("createExcelFavouriteCompany"),
  getFavouriteDetails: getApiUrl("getFavouritesDetails"),
  getAddressDetails: getApiUrl("getAddressDetails"),
  getDownloadNotificationDetails: getApiUrl("getNotificationDetails"),
  getDownloadAllContactInAddressBook: getApiUrl("CompanyContactDetails/downloadAddressbookOfUser"),
  getDownloadShipments: getApiUrl("getDownloadShipments"),
  getProfileSlugID: getApiUrl("getProfileSlugID"),
  getDashboardData: getApiUrl("userDashboard"),
  getPostSearchResults: getApiUrl("postSearchRecomendation"),
};

export const matchTypeOptionsDictionary = [
  { value: "contains", label: "Contains" },
  { value: "exact", label: "Exact Phrase" },
];

export const redirectionInCountryDictionary = {
  companyProfile: "company-profile",
  hsCodeProfile: "hs-code-profile",
  itemNumber: "item-number",
  email: "Email",
  port: "ports",
  logistics: "logistic-companies",
  tradeLane: "trade-lane",
};

export const redirectionTypePayload = {
  portOfLading: "port_of_lading",
  portOfUnlading: "port_of_unlading",
  vocc: "vocc",
  nvocc: "nvocc",
  freightForwarder: "freight_forwarder",
  shipper: "exporters",
  consignee: "importers",
  logistics: "logistics",
  sixDigitHsCode: "hs_code",
  tradeLane: "trade_lane",
  hsCode: "hsCode",
};
export const redirectionTypeKey = {
  port_of_lading: "portOfLading",
  port_of_unlading: "portOfUnlading",
  vocc: "vocc",
  nvocc: "nvocc",
  freight_forwarder: "freightForwarder",
  trade_lane: "tradeLane",
};

export const redirectingProfileEnum = {
  portOfLading: { redirectionType: redirectionInCountryDictionary.port, key: "portOfLading", payloadType: "port" },
  portOfUnlading: { redirectionType: redirectionInCountryDictionary.port, key: "portOfUnlading", payloadType: "port" },
  vocc: { redirectionType: redirectionInCountryDictionary.logistics, key: "vocc", payloadType: "logistics" },
  nvocc: { redirectionType: redirectionInCountryDictionary.logistics, key: "nvocc", payloadType: "logistics" },
  freightForwarder: { redirectionType: redirectionInCountryDictionary.logistics, key: "freightForwarder", payloadType: "logistics" },
  consignee: { redirectionType: redirectionInCountryDictionary.companyProfile, key: "importers", payloadType: "company" },
  shipper: { redirectionType: redirectionInCountryDictionary.companyProfile, key: "exporters", payloadType: "company" },
  logistics: { redirectionType: redirectionInCountryDictionary.companyProfile, key: "logistics", payloadType: "company" },
  sixDigitHsCode: { redirectionType: redirectionInCountryDictionary.hsCodeProfile, key: "hs_code", payloadType: "hs-code" },
  tradeLane: { redirectionType: redirectionInCountryDictionary.tradeLane, key: "tradeLane", payloadType: "trade_region" },
  hsCode: { redirectionType: redirectionInCountryDictionary.hsCodeProfile, key: "hs_code", payloadType: "hs-code" },
};

export const redirectionCompanyTypeDictionary = {
  importer: {
    key: "I",
    value: "importer_company_id",
  },
  exporter: {
    key: "E",
    value: "exporter_company_id",
  },
  logistics: {
    key: "L",
    value: "logistics_company_id",
  },
};

export const requestObjectTypeDictionary = {
  search: "SEARCH",
  reloadSearch: "RELOAD",
  exporters: "EXPORTERS",
  importers: "IMPORTERS",
  logistics: "LOGISTICS",
  filter: "FILTER",
  analytics: "ANALYTICS",
  pagination: "PAGINATION",
};

export const tabHeadingDictionary = {
  shipments: "shipments",
  analytics: "analytics",
  exporters: "exporters",
  importers: "importers",
  logistics: "logistics",
  whatYouAreMissing: "whatYouAreMissing",
  reports: "reports",
};

export const countryTypeDictionary = {
  import: "import",
  export: "export",
};

export const categoryName = {
  consigneeDetails: "Consignee",
  shipperDetails: "Shipper",
  ports: "Ports",
  carrierDetails: "Carrier",
  cargoDetails: "Cargo",
  customsDetails: "Customs Details",
  freightType: "Freight",
  billlading: "Bill of Lading",
  dataSource: "Data Source",
};

export const categoryType = {
  billlading: "billlading",
  consigneeDetails: "consigneeDetails",
  shipperDetails: "shipperDetails",
  ports: "ports",
  carrierDetails: "carrierDetails",
  cargoDetails: "cargoDetails",
  freightType: "freightType",
  dataSource: "dataSource",
};

export const analyticsMainLabelOptions = {
  shipments: "Shipments",
  teu: "TEUs",
  value: "USD",
  weight: "Weight (kg)",
  //  shipments_percentage: '% of shipments',
  //  teu_percentage: '% of TEUs' ,
  //  weight_percentage: '% of weight' ,
  //  value_percentage: '% of value'
};
export const trackingPlanEnum = {
  free: {
    key: "_free",
    value: "FREE",
  },
  basic: {
    key: "_basic",
    value: "BASIC",
  },
  essential: {
    key: "_essential",
    value: "ESSENTIAL",
  },
  plus: {
    key: "_plus",
    value: "PLUS",
  },
  starter: {
    key: "_starter",
    value: "STARTER",
  },
  advanced: {
    key: "_advanced",
    value: "ADVANCED",
  },
  enterprise: {
    key: "_enterprise",
    value: "ENTERPRISE",
  },
  proLite: {
    key: "_pro_lite",
    value: "PRO LITE",
  },
  pro2: {
    key: "_pro2",
    value: "PRO2",
  },
  pro: {
    key: "_pro",
    value: "PRO",
  },
  unknown: {
    key: "unknown",
    value: "UNKNOWN",
  },
};
export const timeFrameOptions = [
  { value: "year", label: "Yearly" },
  { value: "month", label: "Monthly" },
  { value: "quarter", label: "Quarterly" },
];
export const searchTypeCustomStyles = {
  control: (base) => ({
    ...base,
    height: 32,
    minHeight: 32,
    backgroundColor: "#fff",
    borderRadius: "4px",
    fontSize: "14px",
    fontWeight: 600,
  }),
  menu: (base) => ({
    ...base,
    fontSize: "14px",
    fontWeight: 600,
    padding: "8px",
  }),
  option: (base, { isDisabled, isFocused, isSelected }) => ({
    ...base,
    backgroundColor: isDisabled ? null : isSelected ? "rgba(111, 8, 241, 0.1)" : isFocused ? "rgba(111, 8, 241, 0.1)" : null,
    color: isDisabled ? null : isSelected ? "#1a1722" : isFocused ? "#1a1722" : null,
    cursor: "pointer !important",
    marginBottom: "8px",
  }),
};
export const searchPhraseDictionary = {
  entire_bill_of_lading: "entire_bill_of_lading",
  product_description: "product_description",
  product_hscode: "product_hscode",
  exporters: "exporters",
  importers: "importers",
  allCategory: "allCategory",
  chemical_description: "chemical_description",
  ports: "ports",
  logistics: "logistics",
  product_category: "product_category",
};
export const hsCodeTypeDictionary = {
  shipment: "shipment",
  viewShipment: "view-shipment",
  conditionalViewShipment: "conditional-view-shipment",
};
export const crmList = ["Salesforce", "Zoho", "Hubspot", "Microsoft Dynamics", "Salesloft", "Other"];

export const CONTINENT_LIST = [
  {
    label: "North America",
    value: "NA",
    isChecked: {
      import: false,
      export: false,
    },
  },
  {
    label: "Asia",
    value: "ASIA",
    isChecked: {
      import: false,
      export: false,
    },
  },
  {
    label: "Central and South America",
    value: "CSA",
    isChecked: {
      import: false,
      export: false,
    },
  },
  {
    label: "Latin America",
    value: "LTM",
    isChecked: {
      import: false,
      export: false,
    },
  },
  {
    label: "Europe",
    value: "EU",
    isChecked: {
      import: false,
      export: false,
    },
  },
  {
    label: "Africa",
    value: "AFRICA",
    isChecked: {
      import: false,
      export: false,
    },
  },
  {
    label: "Mirror Datasets",
    value: "MIRROR",
    isChecked: {
      import: false,
      export: false,
    },
  },
];
